import React, { useCallback, useState } from 'react';

import './contact.css';

const Contact = () => {


  const [provider, setProvider] = useState('')
  const [profile, setProfile] = useState(null)

  const onLoginStart = useCallback(() => {
    alert('login start')
  }, [])

  const onLogoutSuccess = useCallback(() => {
    setProfile(null)
    setProvider('')
    alert('logout success')
  }, [])
  return (
    <section className="" id="contact">
      <h5>Lets</h5>
      <h2>Contact Me</h2>

      <div className="contactme" >  <span  className="contactme-des"> Let's do something amazing ! </span></div>
      <div className="contactme" >  <span  className="contactme-des-sub"> I am available for freelance work.</span></div>

      <div className="mymail"> <a href="mailto:praveen.i7premasinghe@gmail.com">  Praveen.i7premasinghe@gmail.com <svg className='mymailicon' width="40" height="40" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.654 25.6226L23.5214 20.9997L21.6644 26.9017L24.0589 27.6551L27.1998 17.6723L17.2171 14.5315L16.4637 16.926L22.3656 18.7829L13.4983 23.4058L14.654 25.6226ZM31.8108 15.2685C32.5697 16.7241 33.0344 18.3149 33.1784 19.95C33.3225 21.5852 33.1431 23.2328 32.6504 24.7986C32.1577 26.3645 31.3615 27.818 30.3071 29.0761C29.2527 30.3342 27.9608 31.3723 26.5052 32.1312C23.5655 33.6637 20.1374 33.9658 16.9751 32.9708C13.8127 31.9758 11.1751 29.7653 9.64253 26.8256C8.88368 25.37 8.41896 23.7792 8.2749 22.144C8.13084 20.5088 8.31027 18.8613 8.80294 17.2954C9.79792 14.1331 12.0084 11.4955 14.9481 9.9629C17.8878 8.43032 21.3159 8.12831 24.4783 9.1233C27.6406 10.1183 30.2782 12.3288 31.8108 15.2685Z" fill="#EEFF45"/>
</svg> </a> 

</div>


 

    </section>
  )
};

export default Contact;